import { useQuery, UseQueryResult } from 'react-query';
import { Thread } from '../../../types/Discord';
import api from '../../../utils/api/api';
import { API_DISCORD_THREAD_BY_CHANNEL_ID, API_DISCORD_THREAD_BY_TAG } from '../../../utils/api/constants';
import { QueryTagParams } from '../../../pages/forum/threads/constants';

interface ThreadsByTagResponse {
  threads: Thread[];
  total: number;
}

export const useThreadsByTag = (tagId: string, options: QueryTagParams): UseQueryResult<ThreadsByTagResponse, unknown> => {
  // Destructure options with default values to ensure they are not undefined
  const { skip = 0, limit = 6 } = options;

  return useQuery(
    ['threadsByTag', tagId, skip, limit],
    async () => {
      const queryParams = new URLSearchParams();

      if (skip) queryParams.append('skip', String(skip));
      if (limit) queryParams.append('limit', String(limit));

      const { data } = await api.get<ThreadsByTagResponse>(`${API_DISCORD_THREAD_BY_TAG}/${tagId}?${queryParams.toString()}`);
      return data;
    },
    {
      retry: 0,
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: true,
    },
  );
};
